import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {change, Field} from 'redux-form';
import {connect} from 'react-redux';
import {
    required
} from 'admin-on-rest';
import {compose} from 'recompose';
import {RESOURCES as locationResources} from '../fuseLocationsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';

/**
 * A SelectInput component with Location choices populated with IDs and names.
 *
 */
class LocationsWithIdsSelectInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectChoices: [],
            selectedId: null
        };

        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentDidMount() {
        if (this.props.clearOnMount) {
            this.setState({
                selectedId: ''
            });
            if (this.props.onSelectChange) {
                this.props.onSelectChange(this.props.formName, this.props.source, '', '');
            }
            this.props.dispatch(change(this.props.formName, this.props.source, '', ''));
        }
        this.fetchData();
    }

    /**
     * Checks for validation errors
     *
     * @return {*}
     */
    handleValidation = () => {
        let error = null;
        if (this.state) {
            if (this.state.selectedId === null || this.state.selectedId === '' || this.state.selectedId !== null) {
                error = this.props.errorRequiredMessage;
            }
        }
        return error;
    };

    validateField = [required, this.handleValidation];

    fetchData() {
        // Assemble the URI
        const params = {
            filter: {},
            pagination: {page: 1, perPage: 10000},
            sort: {field: 'id', order: 'ASC'}
        };
        const resource = locationResources.LocationNames.GET_LIST(params);

        // Retrieve the data and assign results to the Select choices
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        let choices = this.assembleChoiceNames(result.data.payload);
                        this.setState({
                            selectChoices: choices
                        });
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    assembleChoiceNames(choices) {
        // Set select label: ID - Name
        for (let choice of choices) {
            const id = (choice.id) ? choice.id : '';
            const name = (choice.name) ? ' - ' + choice.name : '';
            choice.display_name = id + name;
        }
        return choices;
    }

    handleSelectChange(event, index) {
        const selectedId = index;
        // Retrieve the Location from the choices list based on the selected ID
        if (selectedId) {
            const location = this.state.selectChoices.find(p => p.id === selectedId);
            if (location) {
                this.setState({
                    selectedId: selectedId
                });
                if (this.props.onSelectChange) {
                    this.props.onSelectChange(this.props.formName, this.props.source, location.id, location.name);
                }
                this.props.dispatch(change(this.props.formName, this.props.source, location.id, location.name));
            }
        } else {
            this.setState({
                selectedId: ''
            });
            if (this.props.onSelectChange) {
                this.props.onSelectChange(this.props.formName, this.props.source, '', '');
            }
            this.props.dispatch(change(this.props.formName, this.props.source, '', ''));
        }
    }

    render() {
        return (
            <span>
                <Field name={this.props.source}
                       component={VirtualizedSelectInput}
                       choices={this.state.selectChoices}
                       label={this.props.label}
                       optionText="display_name"
                       onChange={this.handleSelectChange}
                       required={this.props.isRequired}
                       validate={(this.props.isRequired) ? this.validateField : undefined}
                       allowEmpty
                       options={{
                           className: 'full-width',
                           clearable: false,
                           placeholder: this.props.label,
                           required: this.props.isRequired
                       }}
                />
            </span>
        );
    }
}

LocationsWithIdsSelectInput.propTypes = {
    addField: PropTypes.bool.isRequired,
    clearOnMount: PropTypes.bool,
    formName: PropTypes.string,
    isRequired: PropTypes.bool,
    onSelectChange: PropTypes.func,
    selectedId: PropTypes.string,
    source: PropTypes.string
};

LocationsWithIdsSelectInput.defaultProps = {
    addField: true,
    clearOnMount: false,
    formName: 'record-form',
    isRequired: false,
    selectedId: null,
    source: 'location_id'
};

const enhance = compose(
    connect()
);

export default enhance(LocationsWithIdsSelectInput);



// WEBPACK FOOTER //
// ./src/Fuse/components/LocationsWithIdsSelectInput.js